import { useEffect } from 'react';
import { safeAsync } from '@/utils/global/safeAsync';
import { resolveClientCurrency } from '@/domain/currency/utils/resolveCurrency';
import { useStore } from '@/providers/app-store-provider';
import { getStoreState } from '@/store';

export function useInitCurrency() {
  const setCurrency = useStore((state) => state.setCurrency);

  useEffect(() => {
    safeAsync(async () => {
      /**
       * 这个 CurrencyList 可能来自 SSR 缓存，IP 判断会不准确
       * 如果走到 IP 判断，resolveClientCurrency 内部会强制重新拉取一次
       */
      const currencyListSnapshot = getStoreState().currencyList;
      const info = await resolveClientCurrency(currencyListSnapshot);

      switch (info.source) {
        case 'URL':
        case 'IP':
          setCurrency(info.currency, { persist: true });
          break;
        case 'Cookie':
        case 'Env':
        default:
          setCurrency(info.currency, { persist: false });
          break;
      }
    });
  }, [setCurrency]);
}
